module.exports = __webpack_public_path__ + "img/telephone.a5e9c550.svg";